import types from '../mutation-types';
import AiAgentRunsAPI from '../../api/aiAgentRuns';

export const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    perPage: 25,
  },
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRuns($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  fetchRuns: async ({ commit }, { agentId, page = 1, perPage = 25 } = {}) => {
    commit(types.SET_AI_AGENT_RUNS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await AiAgentRunsAPI.index({ agentId, page, perPage });
      const records = Array.isArray(data) ? data : data.data || [];
      const meta = data.meta || {};
      commit(types.SET_AI_AGENT_RUNS, records);
      commit(types.SET_AI_AGENT_RUNS_META, {
        currentPage: meta.current_page || page,
        totalPages: meta.total_pages || 1,
        totalCount: meta.total_count || records.length,
        perPage: meta.per_page || perPage,
      });
    } catch (error) {
      // ignore
    } finally {
      commit(types.SET_AI_AGENT_RUNS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_AI_AGENT_RUNS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_AI_AGENT_RUNS]($state, runs) {
    $state.records = runs || [];
  },
  [types.SET_AI_AGENT_RUNS_META]($state, meta) {
    $state.meta = { ...$state.meta, ...meta };
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
